// extracted by mini-css-extract-plugin
export var acitonButtons = "_gx-0";
export var additionalIcon = "_gx-f";
export var block = "_gx-1";
export var blockContent = "_gx-7";
export var blockDescription = "_gx-8";
export var blockIcon = "_gx-9";
export var blockTitle = "_gx-6";
export var border = "_gx-a";
export var center = "_gx-l";
export var edge = "_gx-b";
export var edgeLabel = "_gx-c";
export var edgePath = "_gx-d";
export var error = "_gx-e";
export var flowchart = "_gx-g";
export var flowchartContent = "_gx-h";
export var highlighted = "_gx-3";
export var hover = "_gx-4";
export var icon = "_gx-i";
export var left = "_gx-m";
export var navButton = "_gx-j";
export var navButtons = "_gx-k";
export var right = "_gx-n";
export var selected = "_gx-2";
export var small = "_gx-5";